<template>
  <div class="row video pt-4 pb-4 w-50">
    <div class="col text-center">
      <h3 class="text-white">
        <i class="fas fa-film"></i>
        Desplazamiento de los continentes
      </h3>
      <div class="embed-responsive embed-responsive-16by9">
        <video controls>
          <source src="/video/video-test.mp4" type="video/mp4"/>
        </video>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'video-viewer'
}
</script>
<style lang="scss" scoped>
.video {
  margin: auto;
}
</style>
